// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_cu-0";
export var actionModalContentContainer = "_cu-1";
export var createTagButton = "_cu-2";
export var footerContainer = "_cu-7";
export var fullWidthDivider = "_cu-3";
export var hasCreateTagButton = "_cu-4";
export var noCreateTagButton = "_cu-5";
export var tagsContainer = "_cu-6";
export var tagsModalContentContainer = "_cu-8";